import ModalDefault from "../../../../common/components/modal/modal-default";
import React, {useEffect, useState} from "react";
import FieldsForm from "../../../../common/components/fields/fields-form";
import {Field, FieldsManager} from "../../../../data/services/fields";
import {updateResource} from "../../../../data/actions/resource";
import LocalStorage from "../../../../util/localStorage";
import Resources from "../../../../data/services/resources";
import {useDispatch, useSelector} from "react-redux";
import {LoaderLarge} from "../../../../common/components/loader";
import InfoParagraph from "../../../../common/components/info-paragraph";

export default function SetFactoringJobStatusModal({show, onClose, onSubmitted, selectedRows, piggyResource, query, translate}) {
    const dispatch = useDispatch();

    const resource = useSelector(state => state.resource);
    const isLoading = resource.isLoading;
    const [fields, setFields] = useState(() => getFields());

    function submit() {
        const validatedFields = FieldsManager.validateFields(fields);
        if (!FieldsManager.checkFieldsForErrors(validatedFields)) {
            setFields(validatedFields);
            return null;
        }

        const isSentToFactoring =
            !!FieldsManager.getFieldKeyValues(fields).IsSentToFactoring;

        const params = {
            InvoiceIDs: Object.keys(selectedRows),
            IsSentToFactoring: isSentToFactoring
        };

        dispatch(updateResource({
            user: LocalStorage.get('user'),
            params: params,
            resource: Resources.InvoiceFactoringJobStatus,
            piggyResource: piggyResource,
            query: query,
            errorMessage: true,
            successMessage: translate('text.factoring_job_status_updated')
        }));

        onSubmitted();
    }

    function handleInputChange(name, value) {
        const fieldsUpdate = FieldsManager.updateField(fields, name, value);
        fieldsUpdate[name].errorMessage = "";
        setFields(fieldsUpdate);
    }

    function getFields() {
        return {
            IsSentToFactoring: new Field('IsSentToFactoring', false, [''], false, 'checkbox', {
                addContainerClass: "col-span-full"
            })
        }
    }

    useEffect(() => {
        if (show) {
            setFields(getFields());
        }
    }, [show]);

    return <ModalDefault
        show={!!show}
        widthClass={'max-w-lg'}
        title={translate('text.set_factoring_job_status')}
        buttonLabel={translate("btn.save")}
        onButtonClick={submit}

        closeButtonLabel={translate('btn.Close')}
        onClose={onClose}
    >
        <div className="p-6 grid grid-cols-12 gap-y-4 relative">
            <InfoParagraph
                type="warning"
                message={translate('text.factoring_job_status_warning')}
                addClass="col-span-full"
            />

            <FieldsForm
                fieldsState={fields}
                isLoading={isLoading}
                onChange={handleInputChange}
                translate={translate}
            />

            {isLoading && (
                <LoaderLarge/>
            )}
        </div>
    </ModalDefault>
}
